import React from "react";
import MobileNav from "../../../components/navbar/MobileNav";
import MainEvents from "../../../components/events/MainEvents";
import { reqOptions, HOST_URL } from "../../../assets/js/help_func";
import Error404 from "../../../components/Status/Error404";
import { useDispatch, useSelector } from "react-redux";
import { setUsername } from "../../../store/actions/setUsername";

const Events = ({ data, status, username }) => {
	const dispatch = useDispatch();
	const company_username = useSelector((state) => state.username.company);

	if (username && !company_username) {
		dispatch(setUsername(username));
	}

	if (status == 200) {
		return (
			<div>
				<MobileNav events="active" />
				<section className="control_top container">
					<MainEvents data={data} username={username} />
				</section>
			</div>
		);
	} else {
		return <Error404 />;
	}
};

export default Events;

export async function getServerSideProps(context) {
	const { params, req, res, query } = context;
	const { leads } = params;

	const objects = { username: leads };

	let requestOptions = reqOptions("GET", null);
	const response = await fetch(
		HOST_URL + `/api/v1/events/${leads}/`,
		requestOptions
	).then((res) => {
		objects["status"] = res.status;
		if (res.ok) return res.json();
		else return { message: "No record" };
	});

	objects["data"] = await response;
	console.log(objects);

	return {
		props: objects,
	};
}
